import { createAsyncThunk } from '@reduxjs/toolkit'

import { client } from '~publish/legacy/apollo-client'
import { graphql } from '~publish/graphql'
import type { AppDispatch, RootState } from '~publish/legacy/store'

type TAccount = {
  currentOrganization: {
    limits: {
      generateContent: number
    }
    billing: {
      canGenerateContent: boolean
      generateContentTokensLeft: number
    }
  }
}

const QUERY_LIMITS = graphql(/* GraphQL */ `
  query queryLimits {
    account {
      id
      currentOrganization {
        id
        limits {
          generateContent
        }
        billing {
          ... on OBBilling {
            id
            canGenerateContent
            generateContentTokensLeft
          }
        }
      }
    }
  }
`)

const queryLimits = createAsyncThunk<
  TAccount,
  void,
  { state: RootState; dispatch: AppDispatch }
>('ai/queryTokens', async (_, { rejectWithValue }) => {
  try {
    const response = await client.query<{ account: TAccount }>({
      query: QUERY_LIMITS,
    })

    const account = response.data?.account

    if (!account) {
      return rejectWithValue('Failed to load AI limits')
    }

    return account
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Failed to load AI limits',
    )
  }
})

export { queryLimits }
